function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from 'react';
export default function useId(idOverride) {
  var _React$useState = React.useState(idOverride),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      defaultId = _React$useState2[0],
      setDefaultId = _React$useState2[1];

  var id = idOverride || defaultId;
  React.useEffect(function () {
    if (defaultId == null) {
      setDefaultId("tangram-react-icon-".concat(Math.round(Math.random() * 1e6)));
    }
  }, [defaultId]);
  return id;
}